import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom'
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrTextInput from '../components/FrTextInput'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import FrDatePicker from '../components/FrDatePicker'
import {fileExcel} from 'react-icons-kit/icomoon/fileExcel'
import ReactExport from "react-data-export";


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';
import Legendas from '../components/Legendas';

const swal = withReactContent(Swal)

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

function NotasFiscais(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [exportData, setExportData] = useState([])
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [selected, setSelected] = useState([])

  const [comboEstado, setComboEstado] = useState([{ value: '', display: '' }])
  const [comboSimNao, setComboSimNao] = useState([{ value: 'S', display: 'Sim' }], [{ value: 'N', display: 'Não' }])
  const [comboTipoPessoa, setComboTipoPessoa] = useState([{ value: 'F', display: 'PF' }], [{ value: 'J', display: 'PJ' }])

  const columns = [
    { id: 'color', icon: true, numeric: false, label: '', align: 'left', minWidth: 50 },
    { id: 'numero_nota', numeric: false, label: 'Nº Nota', align: 'left', minWidth: 100 },
    { id: 'num_rps', numeric: false, label: 'Nº Rps', align: 'left', minWidth: 150 },
    { id: 'formatdata_competencia', numeric: false, label: 'Competência', align: 'left', minWidth: 100 },
    { id: 'formatdata_emissao', numeric: false, label: 'Emissão', align: 'left', minWidth: 100 },
    { id: 'formatdata_vencimento', numeric: false, label: 'Data Venc.', align: 'left', minWidth: 100 },
    { id: 'formatdata_pagamento', numeric: false, label: 'Data Pag.', align: 'left', minWidth: 100 },
    { id: 'tomador_nome', numeric: false, label: 'Tomador', align: 'left', minWidth: 350 },
    { id: 'tomador_cpf_cnpj', numeric: false, label: 'CPF/CNPJ', align: 'left', minWidth: 150 },
    { id: 'tipo', numeric: false, label: 'tipo', align: 'left', minWidth: 150 },
    { id: 'contrato', numeric: false, label: 'contrato', align: 'left', minWidth: 150 },
    { id: 'valor_servico', numeric: false, label: 'Valor', align: 'left', minWidth: 150 },
    { id: 'valor_total', numeric: false, label: 'Valor Liquido', align: 'left', minWidth: 150 },
    { id: 'nomefpg', numeric: false, label: 'Forma Pagamento', align: 'left', minWidth: 150 },
    { id: 'nomefpg', numeric: false, label: 'NSU', align: 'left', minWidth: 150 },

  ]

  const legendas = [
    {descricao: 'Não transmitidas', color: '#fdfd96'},
    {descricao: 'Notas com erro', color: '#fdcae1'},
    {descricao: 'Trasmitidas com Sucesso', color: '#cff6c8'},
    {descricao: 'Queda no meio da transmissão', color: '#bbd5f9'},
    {descricao: 'Canceladas', color: '#f4c284'},
  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      setComboEstado(await api.getComboData('estados'))
      setenableAdd(await api.getAcessos('Notas Fiscais', 'Inclusao'))
      setenableEdit(await api.getAcessos('Notas Fiscais', 'Alteracao'))
      setenableDel(await api.getAcessos('Notas Fiscais', 'Exclusao'))


      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)
      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    queryObject.buscar = true
    setFiltered(true)
    window.history.replaceState({ filtered: true }, 'filter', "/salute/notas_fiscais?" + objectToQueryString(queryObject));
    swal.fire({
      html: <FrLoading text="Buscando dados..." />,
      showConfirmButton: false,
      allowOutsideClick: false,
      allowEscapeKey: false
    })
    api.get('/notas_fiscais', { params: queryObject }).then(r => {
      setData(r.data)
      setExportData(r.data)
      swal.close()
    })
  }


  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/notas_fiscais');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  const handleChange = (e) => {
    const auxValues = { ...filter };
    auxValues[e.target.name] = e.target.value;
    setFilter(auxValues);
  };

  const enviarNotas = (e) => {
    console.log(selected)
    e.preventDefault();
    api.post('notas_fiscais/envia_nota?selected='+selected).then(r=>{ 
      console.log(r)
    })
  }

  return (
    <div className="Manut">
      <NavBar />

      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>NotasFiscais</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrSelect
                value={filter.fk_sed || ''}
                style={{ width: 170 }}
                name="fk_sed"
                id="fk_sed"
                label='Emissor'
                data={comboEstado}
                onChange={handleChange}
              />

              <FrTextInput
                value={filter.tomador_nome || ''}
                style={{ width: 330 }}
                name="tomador_nome"
                id="tomador_nome"
                color="#389492"
                label="Tomador"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
              
              <br/>

              <FrDatePicker
                value={(filter.data_emissao_ini || '').split('T')[0]}
                name="data_emissao_ini"
                id="data_emissao_ini"
                color="#49573B"
                label="Período Emissao"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.data_emissao_fim || '').split('T')[0]}
                name="data_emissao_fim"
                id="data_emissao_fim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrDatePicker
                value={(filter.data_competencia_ini || '').split('T')[0]}
                name="data_competencia_ini"
                id="data_competencia_ini"
                color="#49573B"
                label="Período Competência"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.data_competencia_fim || '').split('T')[0]}
                name="data_competencia_fim"
                id="data_competencia_fim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <br/>
              <FrDatePicker
                value={(filter.data_vencimento_ini || '').split('T')[0]}
                name="data_vencimento_ini"
                id="data_vencimento_ini"
                color="#49573B"
                label="Período Vencimento"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.data_vencimento_fim || '').split('T')[0]}
                name="data_vencimento_fim"
                id="data_vencimento_fim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrDatePicker
                value={(filter.data_pagamento_ini || '').split('T')[0]}
                name="data_pagamento_ini"
                id="data_pagamento_ini"
                color="#49573B"
                label="Período Pagamento"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.data_pagamento_fim || '').split('T')[0]}
                name="data_pagamento_fim"
                id="data_pagamento_fim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <br/>

              <FrSelect
                value={filter.tipo_contrato || ''}
                style={{ width: 170 }}
                name="tipo_contrato"
                id="tipo_contrato"
                label='Tipo Contrato'
                data={comboTipoPessoa}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.com_erro || ''}
                style={{ width: 170 }}
                name="com_erro"
                id="com_erro"
                label='Com Erro'
                data={comboSimNao}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.enviadas || ''}
                style={{ width: 170 }}
                name="enviadas"
                id="enviadas"
                label='Enviadas'
                data={comboSimNao}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.canceladas || ''}
                style={{ width: 170 }}
                name="canceladas"
                id="canceladas"
                label='Canceladas'
                data={comboSimNao}
                onChange={handleChange}
              />

              <br/>

              <FrTextInput
                value={filter.fk_lot || ''}
                style={{ width: 330 }}
                name="fk_lot"
                id="fk_lot"
                color="#389492"
                label="Nº Lote"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <FrTextInput
                value={filter.contrato || ''}
                style={{ width: 330 }}
                name="contrato"
                id="contrato"
                color="#389492"
                label="Contrato"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
            {/* CHECK BOX Ocultar Lotes c/ queda */}

              <br/>

              <FrTextInput
                value={filter.tomador_nome || ''}
                style={{ width: 330 }}
                name="tomador_nome"
                id="tomador_nome"
                color="#389492"
                label="Tomador"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />

              <FrSelect
                value={filter.fk_est || ''}
                style={{ width: 170 }}
                name="fk_est"
                id="fk_est"
                label='Estado'
                data={comboSimNao}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.fk_cid || ''}
                style={{ width: 170 }}
                name="fk_cid"
                id="fk_cid"
                label='Canceladas'
                data={comboSimNao}
                onChange={handleChange}
              />

              <FrTextInput
                value={filter.erro || ''}
                style={{ width: 330 }}
                name="erro"
                id="erro"
                color="#389492"
                label="Erro"
                variant="outlined"
                size="small"
                onChange={handleChange}
              />
            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <Link to="/salute/notas_fiscais/registro">
                  <button >
                    <Icon icon={ic_add_box} size={18} />
                    Novo Registro
                  </button>
                </Link>}

                <ExcelFile 
                  element={
                    <button 
                      type='button'  
                      onClick={console.log(exportData)}
                    >
                      <Icon icon={fileExcel} size={18} />
                      Exportar XLS
                    </button>
                  } 
                  filename="Notas Fiscais">
                <ExcelSheet data={exportData} name="Notas Fiscais">
                  <ExcelColumn label="Nº Nota" value="numero_nota" />
                  <ExcelColumn label="Nº Rps" value="num_rps" />
                  <ExcelColumn label="Competência" value="formatdata_competencia" />
                  <ExcelColumn label="Emissão" value="formatdata_emissao" />
                  <ExcelColumn label="Data Venc." value="formatdata_vencimento" />
                  <ExcelColumn label="Data Pag." value="formatdata_pagamento" />
                  <ExcelColumn label="Tomador" value="tomador_nome" />
                  <ExcelColumn label="CPF/CNPJ" value="tomador_cpf_cnpj" />
                  <ExcelColumn label="Tipo" value="tipo" />
                  <ExcelColumn label="Contrato" value="contrato" />
                  <ExcelColumn label="Valor" value="valor_servico" />
                  <ExcelColumn label="Valor Liquido" value="valor_total" />
                  <ExcelColumn label="Forma Pagamento" value="nomefpg" />

                </ExcelSheet>
              </ExcelFile>
              <button onClick={enviarNotas}>
                <Icon icon={ic_delete} size={18} />
                Enviar Notas
              </button>
            </div>
          </form>
        <Legendas legenda={legendas} />
        </div>
        <br />
        <div className="tableDiv">
          <FrTable 
            regName="notas_fiscais" 
            columns={columns} 
            searched={filtered} 
            codeName="pk_ntf" 
            page={'NotasFiscais'} 
            data={data} 
            enableEdit={enableEdit} 
            enableDel={enableDel} 
            selected={selected}
            setSelected={setSelected}
            mostraCheck="S"
          />
        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default NotasFiscais;
